import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { parcoService } from '@/services/parco.service';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { GuideCard } from '@/components/guide/GuideCard';
import { Reveal, RevealGroup, fadeUp } from '@/components/public/anim';
import { Users2, ShieldCheck } from 'lucide-react';

const SectionHead = () => (
  <div className="mx-auto max-w-2xl text-center">
    <span className="inline-flex items-center gap-1.5 rounded-full bg-[hsl(var(--brand-sun)/0.22)] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[hsl(var(--brand-bark))]">
      <Users2 className="h-3.5 w-3.5" />Le nostre guide
    </span>
    <h2 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl">Le guide del Parco</h2>
    <p className="mt-3 text-base leading-relaxed text-muted-foreground">
      Professionisti del territorio che ti accompagnano tra sentieri, laghi e foreste della Sila. Scopri il loro
      profilo e prenota un'escursione.
    </p>
  </div>
);

export const ParkGuidesShowcase = () => {
  const [guides, setGuides] = useState(null); // null = loading

  useEffect(() => {
    let alive = true;
    parcoService.publicGuides()
      .then((data) => { if (alive) setGuides(Array.isArray(data) ? data : []); })
      .catch(() => { if (alive) setGuides([]); });
    return () => { alive = false; };
  }, []);

  // Errore/empty: non mostrare la sezione
  if (guides !== null && guides.length === 0) return null;

  return (
    <section className="sila-section py-16 sm:py-24" data-testid="park-guides-showcase">
      <Reveal><SectionHead /></Reveal>

      {guides === null ? (
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <Card key={i} className="p-4">
              <div className="flex items-start gap-4">
                <Skeleton className="h-16 w-16 rounded-full" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-5 w-2/3" />
                  <Skeleton className="h-4 w-full" />
                </div>
              </div>
              <Skeleton className="mt-4 h-16 w-full" />
            </Card>
          ))}
        </div>
      ) : (
        <RevealGroup className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {guides.map((g) => (
            <motion.div key={g.id} variants={fadeUp}>
              {/* Card IDENTICA all'anteprima pubblica del CRM (GuideCard variant="full"),
                  resa cliccabile verso il profilo pubblico. */}
              <Link
                to={`/guida/${g.id}`}
                data-testid={`park-guide-card-${g.id}`}
                className="group block h-full rounded-2xl transition-shadow duration-200 hover:shadow-[var(--shadow-md)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
              >
                <GuideCard guide={g} variant="full" className="h-full" testId={`park-guide-${g.id}`} />
              </Link>
            </motion.div>
          ))}
        </RevealGroup>
      )}

      <Reveal>
        <p className="mt-8 flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <ShieldCheck className="h-4 w-4 text-primary" />
          Vuoi diventare una guida della rete Sila Experiences?{' '}
          <Link to="/guida/registrati" className="font-semibold text-primary hover:underline" data-testid="park-guides-cta-register">
            Candidati qui
          </Link>
        </p>
      </Reveal>
    </section>
  );
};

export default ParkGuidesShowcase;
